import { AgCharts } from "ag-charts-react";
import React, { useState } from "react";

const BarChart = ({ data }) => {
  // function getData() {
  // const data = [
  //   { asset: "ACC-077_20240912160937", amount: 20 },
  //   {
  //     asset: "MTJ_AVD_AVD-CR-24-00027_Hayakawa_20240916100955",
  //     amount: 25,
  //   },
  //   {
  //     asset: "MTJ_AVD_AVD-CR-24-00027_Hayakawa_20240914110917",
  //     amount: 35,
  //   },
  //   { asset: "ACC-077_20240912160937", amount: 22 },
  //   {
  //     asset: "MTJ_AVD_AVD-CR-24-00027_Hayakawa_20240916100955",
  //     amount: 12,
  //   },
  // ];

  const maxLength = 15; // Set a fixed length for the asset name part

  // data = data.map((item) => ({
  //   ...item,
  //   // Truncate asset name to maxLength characters, add ellipsis if needed
  //   truncatedLabel:
  //     item.article_title.length > maxLength
  //       ? item.article_title.substring(0, maxLength) + "..."
  //       : item.article_title,
  //   // Keep the original name for marquee effect and amount padding
  //   displayLabel: `${item.article_title.padEnd(
  //     maxLength
  //   )} $${item.count.toLocaleString()}`,
  // }));
  // }

  // data = data.map((items) => ({
  //   count: items.count,
  //   article: items.article_title,
  // }));

  const filteredData = data
    .filter((items) => items.count !== 0) // Only include items where count is not zero
    .map((items) => ({
      count: items.count,
      article: items.article_title,
    }));

  const [options, setOptions] = useState({
    data: filteredData,
    series: [
      {
        type: "donut",
        angleKey: "count",
        labelKey: "article",
        innerRadiusRatio: 0.4,
        sectorLabelKey: "count",
        calloutLabelKey: "article", // No callout labels, just the legend
      },
    ],
    legend: {
      position: "bottom", // Choose position: 'top', 'bottom', 'left', 'right'
      spacing: 50, // Control spacing between legend items
      marker: {
        shape: "circle", // Customize marker shape ('circle', 'square', etc.)
        size: 50, // Marker size adjustment
      },
      item: {
        label: {
          fontSize: 14, // Set font size for legend labels
          fontFamily: "monospace", // Monospace font for consistent label spacing
        },
        // Custom renderer for the legend to add marquee and fixed padding
        renderer: (params) => {
          const { marker, label } = params;
          const { truncatedLabel, displayLabel } = label.datum;

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>{marker}</span>
              <span
                className="marquee"
                title={label.datum.asset} // Shows full asset name on hover
              >
                {truncatedLabel}
              </span>
              <span style={{ marginLeft: "auto" }}>{displayLabel}</span>
            </div>
          );
        },
      },
    },
    width: 500,
    height: 400,
    background: {
      // fill: "#F8F9FA"
      fill: "#fff", // Change to any desired background color
    },
  });

  return <AgCharts options={options} />;
};

export default BarChart;
